import { ChatEvaluationReportPage } from '@/Workspaces/ChatEvaluationTestSet/Evaluation/ChatEvaluationReportPage'
import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const reportSearchSchema = z.object({
  title: z.string().optional().catch(''),
  customerName: z.string().optional().catch(''),
  mode: z.enum(['avg', 'max', 'min']).optional().catch('avg'),
  markdown: z.enum(['true', 'false']).optional().catch('true'),
})

export const Route = createFileRoute(
  '/workspace/$workspaceId/chatEvaluationTestSet/$chatEvaluationTestSetId/test/$chatEvaluationTestId/report',
)({
  validateSearch: (search) => reportSearchSchema.parse(search),
  component: RouteComponent,
})

function RouteComponent() {
  return <ChatEvaluationReportPage />
}
